export class StringExtension {
  isEmpty = (value: string): boolean => {
    return value.trim().length === 0;
  };
}
